import moment from "moment";
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { get } from "lodash";

import { limitCharacterLength } from "~/utils/formatters";
import { LeadCalendarIcon } from "../LeadCalendarIcon";
import { Icon } from "antd";
import {
  CalendarIcon,
  Content,
  Date,
  DateContainer,
  LeadInfo,
  LeadName,
  MainContent,
  Container,
} from "./styles";

export function LeadCard({
  index,
  item,
  showDrawer,
}) {
  const isRevised = get(item, 'additional_data.is_revised', false);
  
  return (
    <Draggable key={index} draggableId={item.id} index={index}>
      {(providedProps, snapshotProps) => {
        const { innerRef, draggableProps, dragHandleProps } = providedProps;
        const { isDragging, isDraggingOver } = snapshotProps;

        return (
          <Container
            ref={innerRef}
            {...draggableProps}
            {...dragHandleProps}
            isDragging={isDragging}
            isDraggingOver={isDraggingOver}
            isRevised={isRevised}
            onClick={() => showDrawer(item)}
          >
            <Content>
              <MainContent>
                <LeadInfo>
                  <DateContainer>
                    <CalendarIcon />
                    <Date>{moment(item.created_at).fromNow()}</Date>
                  </DateContainer>
                  <LeadName>
                    <Icon type="user"/> {limitCharacterLength(item.name, 33)}
                    {item.additional_data && (item.additional_data.source === 'apify' || item.additional_data.apify_integration_id) && (
                      <Icon
                        type="thunderbolt"
                        theme="filled"
                        style={{ marginLeft: 6, color: '#FF7A00', fontSize: 12 }}
                        title="Capturado automaticamente pela integração Apify"
                      />
                    )}
                  </LeadName>
                </LeadInfo>
                <LeadCalendarIcon item={item} />
              </MainContent>
            </Content>
          </Container>
        );
      }}
    </Draggable>
  );
}
